"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResultsDataSource;
(function (ResultsDataSource) {
    ResultsDataSource[ResultsDataSource["DEFAULT"] = 0] = "DEFAULT";
    ResultsDataSource[ResultsDataSource["ATHLINKS"] = 1] = "ATHLINKS";
    ResultsDataSource[ResultsDataSource["CTLIVE"] = 2] = "CTLIVE";
})(ResultsDataSource = exports.ResultsDataSource || (exports.ResultsDataSource = {}));
//# sourceMappingURL=linkageResultResponse.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-model/dist/models/linkageResultResponse.js
 ** module id = 2098
 ** module chunks = 0
 **/